<template>
  <div class="editProject-dropDown-list">
    <img v-on:click="toggleDropDownInput(index)" src="static/icon/H2BOON-list-edit.png" />
    <img v-if="inputValue" v-on:click="toggleDropDownInput(index)" src="static/icon/H2BOON-list-OK.png" />
    <img v-if="!inputValue" v-on:click="toggleDropDownInput(index)" src="static/icon/H2BOON-list-missing.png" />
    <span v-on:click="toggleDropDownInput(index)">{{ title }}</span>
    <div v-show="isDropDownListIndex == index" style="display: flex">
      <!-- @input="updateSimpleProperty('projectIcon', $event)" :value="data" -->
      <inputField
        id="projectIcon"
        class="half"
        v-model="inputValue"
        :readonly="!hasSimplePermissions('saveProjectProperties')"
      />
      <button class="material-button-effect" @click="UpdateDropDownInput(index, inputValue, property)">Spara</button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import inputField from '@/components/form/inputField';
export default {
  data() {
    return {
      inputValue: '',
    };
  },
  props: ['index', 'title', 'property', 'value', 'isDropDownListIndex'],
  methods: {
    /**
     * toggle Drop Down Input event pass parent
     * @param index
     */
    toggleDropDownInput: function (index) {
      this.$emit('toggleDropDown', { index: index });
    },
    /**
     * update Drop Down Input event pass parent
     * @param index, value, property
     */
    UpdateDropDownInput: function (index, value, property) {
      // console.log(index, value, property);
      this.$emit('UpdateDropDownInput', { index, value, property });
    },
  },
  computed: {
    ...mapGetters(['hasSimplePermissions']),
  },
  components: {
    inputField,
  },
  mounted: function () {
    this.inputValue = this.value;
  },
};
</script>
<style>
.editProject-dropDown-list img {
  width: 25px;
  margin-right: 5px;
}
.editProject-dropDown-list span {
  font-family: 'DIN Alternate Bold';
  font-size: 26px;
  cursor: pointer;
}
.editProject-dropDown-list button {
  border: 2px solid #bbb6bb55 !important;
  padding: 5px;
  border-radius: 5px;
  font-size: 18px;
  height: 35px;
  margin-top: 7px;
  line-height: 20px;
  margin-right: 15px;
  position: relative;
}
/* Overlay */
.editProject-dropDown-list .material-button-effect::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgb(var(--pure-material-onprimary-rgb, 255, 255, 255));
  opacity: 0;
  transition: opacity 0.2s;
}

/* Ripple */
.editProject-dropDown-list .material-button-effect::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 50%;
  padding: 50%;
  width: 32px; /* Safari */
  height: 32px; /* Safari */
  background-color: rgb(var(--pure-material-onprimary-rgb, 255, 255, 255));
  opacity: 0;
  transform: translate(-50%, -50%) scale(1);
  transition: opacity 1s, transform 0.5s;
}

/* Hover, Focus */
.editProject-dropDown-list .material-button-effect:hover,
.editProject-dropDown-list .material-button-effect:focus {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.editProject-dropDown-list .material-button-effect:hover::before {
  opacity: 0.08;
}

.editProject-dropDown-list .material-button-effect:focus::before {
  opacity: 0.24;
}

.editProject-dropDown-list .material-button-effect:hover:focus::before {
  opacity: 0.3;
}
/* Active */
/* .material-button-effect:active {
      box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  } */

.editProject-dropDown-list .material-button-effect:active::after {
  opacity: 0.32;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0s;
}
</style>



// WEBPACK FOOTER //
// src/components/project/DropDownList.vue